module.exports = __webpack_public_path__ + "static/media/bg-pattern.93118e6d.png";